import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { pick } from 'lodash'

import { addressFormPropsSelector } from 'address-form'
import { MAX_VAR_CHAR_LENGTH } from 'consts'
import { applyHOCs } from 'helpers'
import { Input, Select, Label, validators } from 'form'
import { formGroup, formGroupButtons } from 'form-group'
import { Grid, GridItem } from 'layout'

import { saveInstitutionBillingAddress } from './actions'
import { INSTITUTION_BILLING_ADDRESS_FORM } from './constants'

const FormGroupButtons = formGroupButtons({ form: INSTITUTION_BILLING_ADDRESS_FORM })

/* Because 🐞: https://github.com/erikras/redux-form/issues/2588 */
const validate = (values, { stateLabel }) => {
  const errors = {}

  if (values.country === 'US' || values.country === 'CA') {
    if (!values.state) {
      errors.state = `Your institution's ${stateLabel} is required`
    }
  }

  return errors
}

const InstitutionBillingAddressForm = (props) => {
  const {
    editing,
    save,
    countryOptions,
    countryPostalPattern,
    countryPostal,
    stateOptions,
    stateLabel
  } = props

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        save()
      }}
    >
      <Grid>
        <GridItem col='1/2' mobile1of1>
          <Label htmlFor='address_line_1'>Address Line 1</Label>
          <Field
            name='address_line_1'
            component={Input}
            validate={validators.required("Your institution's address is required")}
            disabled={!editing}
            maxLength={MAX_VAR_CHAR_LENGTH}
          />
        </GridItem>
        <GridItem col='1/2' mobileHide tabletHide />

        <GridItem col='1/2' mobile1of1>
          <Label htmlFor='address_line_2'>Address Line 2</Label>
          <Field
            name='address_line_2'
            component={Input}
            disabled={!editing}
            maxLength={MAX_VAR_CHAR_LENGTH}
          />
        </GridItem>
        <GridItem col='1/2' mobileHide tabletHide />

        <GridItem col='1/2' tablet1of1 mobile1of1>
          <Label htmlFor='city'>City</Label>
          <Field
            name='city'
            component={Input}
            validate={validators.required("Your institution's city is required")}
            disabled={!editing}
            maxLength={MAX_VAR_CHAR_LENGTH}
          />
        </GridItem>
        <GridItem col='1/2' mobileHide tabletHide />

        <GridItem col='1/2' tablet1of1 mobile1of1>
          <Label htmlFor='country'>Country</Label>
          <Field
            name='country'
            component={Select}
            options={countryOptions.map(({ country_name, country_abbr }) => ({ // eslint-disable-line camelcase
              name: country_name,
              value: country_abbr
            }))}
            validate={validators.required("Your institution's country is required")}
            disabled={!editing}
          />
        </GridItem>
        <GridItem col='1/2' mobileHide tabletHide />

        <GridItem col='1/4' tablet1of3 mobile1of2>
          <Label htmlFor='state'>{stateLabel}</Label>
          <Field
            name='state'
            component={(field) => {
              if (stateOptions.length > 0) {
                return <Select {...field} />
              } else {
                return <Input {...field} />
              }
            }}
            options={stateOptions.map(({ state_abbr }) => ({ // eslint-disable-line camelcase
              name: state_abbr,
              value: state_abbr
            }))}
            disabled={!editing}
          />
        </GridItem>
        <GridItem col='1/4' tablet1of3 mobile1of2>
          <Label htmlFor='postal_code'>{countryPostal}</Label>
          <Field
            name='postal_code'
            component={Input}
            validate={[
              validators.postalCode(countryPostalPattern, `You must enter a valid ${countryPostal}`),
              validators.required(`Your institution's ${countryPostal} is required`)
            ]}
            disabled={!editing}
          />
        </GridItem>
        <GridItem col='1/2' tablet1of3 mobileHide />

        <GridItem col='2/5' tablet2of3 mobile1of1>
          <FormGroupButtons form={INSTITUTION_BILLING_ADDRESS_FORM} />
        </GridItem>
      </Grid>
    </form>
  )
}

export default applyHOCs([
  formGroup({
    form: INSTITUTION_BILLING_ADDRESS_FORM,
    initialValuesSelector: (state, props) => {
      return pick(props.institution, [
        'address_line_1',
        'address_line_2',
        'city',
        'country',
        'state',
        'postal_code'
      ])
    },
    validate
  }),
  connect(
    addressFormPropsSelector(INSTITUTION_BILLING_ADDRESS_FORM),
    { save: saveInstitutionBillingAddress }
  )
])(InstitutionBillingAddressForm)
